import React from 'react'
import { appConfig } from '@/config/app'

interface InstallGuidePageSkeletonProps {
  title: string
  subtitle: string
  ariaLabel: string
}

export const InstallGuidePageSkeleton: React.FC<InstallGuidePageSkeletonProps> = ({ title, subtitle, ariaLabel }) => {
  const uiClassNames = appConfig.installGuide.uiClassNames
  const uiColors = appConfig.ui.colors
  const skeletonConfig = appConfig.installGuide.skeleton

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={ariaLabel}
      className={`flex min-h-screen min-w-screen flex-col items-center justify-end overflow-hidden ${uiColors.pageBg} ${uiClassNames.rootPadding}`}
    >
      <div className={`flex ${uiClassNames.contentWidth} flex-col items-start ${uiClassNames.sectionGap}`}>
        <div className="flex w-full flex-col items-center gap-[25px]">
          <div className="skeleton-round h-[100px] w-[100px]" />
          <div className={`flex ${uiClassNames.contentWidth} flex-col items-center gap-2.5`}>
            <p className={`w-full text-center font-poppins font-bold ${uiClassNames.titleTextSize} ${uiColors.textPrimary}`}>{title}</p>
            <p className={`w-full text-center font-poppins ${uiClassNames.subtitleTextSize} ${uiColors.textSecondary}`}>{subtitle}</p>
          </div>
        </div>

        <div className="flex w-full flex-col items-start gap-2.5">
          <div className="flex w-full flex-col items-center gap-2.5">
            <div className={`flex items-center justify-between ${uiClassNames.deviceHeaderWidth}`}>
              <div className="skeleton h-4 w-24" />
              <div className="skeleton h-4 w-28" />
            </div>

            <div className={`flex h-[52px] w-full items-center ${uiClassNames.linkBoxRounded} ${uiColors.surfaceMid} ${uiClassNames.linkBoxPadding}`}>
              <div className="skeleton h-4 w-full" />
            </div>
          </div>

          <div className="flex w-full flex-col items-start gap-2.5">
            {Array.from({ length: skeletonConfig.cardsCount }).map((_, index) => (
              <div
                key={`ig-skeleton-step-${index}`}
                className={`flex w-full flex-col items-center justify-center ${uiClassNames.cardGap} overflow-hidden ${uiClassNames.cardRounded} ${uiColors.surfaceMid} ${uiClassNames.cardPadding}`}
              >
                <div className="flex w-full items-start justify-between">
                  <div className={uiClassNames.stepIconWrap}>
                    <div className="skeleton-round h-[26px] w-[26px]" />
                  </div>
                  <div className="flex w-[277px] flex-col items-start gap-2.5">
                    <div className="flex w-full flex-col items-start gap-2">
                      <div className="skeleton h-4 w-36" />
                      <div className="skeleton h-4 w-full" />
                    </div>
                    <div className="skeleton h-[34px] w-44 rounded-[100px]" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}